import React from "react";
import { Link } from "react-router-dom";
import { htmlToExcerpt } from "../../utils/sanitizeHtml";
import FitCoverImage from "./FitCoverImage";

/**
 * Open-to-work / looking-for-job teaser for feed and sidebar.
 */
export default function LookingForJobCard({
  post,
  linkPrefix = "/home/looking-for-job",
  compact = false,
  interactive = true,
}) {
  const description =
    post.looking_for_job_description || post.text || post.content || "";
  const excerpt = htmlToExcerpt(description, compact ? 90 : 150);
  const cover = post.cover_image || null;
  const location = post.looking_for_job_location || "";
  const skills = Array.isArray(post.looking_for_job_skills)
    ? post.looking_for_job_skills
    : [];
  const availability = post.looking_for_job_availability || "";
  const canLink = interactive && !!linkPrefix;
  const Wrapper = canLink ? Link : "div";
  const wrapperProps = canLink
    ? {
        to: `${linkPrefix}/${post.id}`,
        style: { textDecoration: "none", color: "inherit", display: "block" },
      }
    : { style: { color: "inherit", display: "block" } };

  return (
    <div style={{ marginTop: compact ? 0 : 4 }}>
      <Wrapper {...wrapperProps}>
        {cover && !compact && (
          <FitCoverImage src={cover} maxHeight={280} radius={10} marginBottom={12} />
        )}
        <div
          style={{
            display: "inline-block",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: 0.4,
            textTransform: "uppercase",
            color: "#1d4ed8",
            background: "#dbeafe",
            padding: "3px 8px",
            borderRadius: 4,
            marginBottom: 8,
          }}
        >
          Looking for job
        </div>
        <h3
          style={{
            fontSize: compact ? 15 : 20,
            fontWeight: 700,
            color: "#102a43",
            margin: "0 0 6px",
            lineHeight: 1.3,
          }}
        >
          {post.title}
        </h3>
        {(location || availability) && (
          <p
            style={{
              margin: "0 0 6px",
              fontSize: compact ? 12 : 13,
              color: "#475569",
            }}
          >
            {[location, availability].filter(Boolean).join(" · ")}
          </p>
        )}
        {skills.length > 0 && (
          <p
            style={{
              margin: "0 0 8px",
              fontSize: compact ? 11 : 12,
              color: "#64748b",
              lineHeight: 1.4,
            }}
          >
            {skills.slice(0, compact ? 4 : 8).join(" · ")}
            {skills.length > (compact ? 4 : 8) ? "…" : ""}
          </p>
        )}
        {excerpt && (
          <p
            style={{
              margin: "0 0 8px",
              fontSize: compact ? 12 : 14,
              color: "#475569",
              lineHeight: 1.45,
            }}
          >
            {excerpt}
          </p>
        )}
        {!compact && canLink && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#1d4ed8",
            }}
          >
            View profile post →
          </span>
        )}
      </Wrapper>
    </div>
  );
}
